import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import TaskItemComponent from './TaskItemComponent'

export const TaskItem = Node.create({
  name: 'todo_item',

  addNodeView () {
    return VueNodeViewRenderer(TaskItemComponent)
  },

  defaultOptions: {
    isEvent: false,
    nested: false,
    HTMLAttributes: {
      class: 'todo_item'
    }
  },

  content () {
    return this.options.nested ? '(paragraph|todo_list)+' : 'paragraph+'
  },

  defining: true,
  draggable: true,

  addAttributes () {
    return {
      isEvent: {
        default: this.options.isEvent
      },
      done: {
        default: false,
        parseHTML: element => ({
          done: element.getAttribute('data-done') === 'true'
        }),
        renderHTML: attributes => ({
          'data-done': attributes.done
        })
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'li[data-type="todo_item"]',
        priority: 51
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['li', mergeAttributes(
      this.options.HTMLAttributes,
      HTMLAttributes,
      { 'data-type': 'todo_item', class: 'todo_item' }
    ), 0]
  },

  addKeyboardShortcuts () {
    const shortcuts = {
      Enter: () => this.editor.commands.splitListItem('todo_item'),
      'Shift-Tab': () => this.editor.commands.liftListItem('todo_item')
    }

    if (!this.options.nested) {
      return shortcuts
    }

    return {
      ...shortcuts,
      Tab: () => this.editor.commands.sinkListItem('todo_item')
    }
  }
})
